module.exports = __webpack_public_path__ + "img/6.7072ffd0.jpg";